import getProductFrequency from 'services/api/productFrequency/getProductFrequency';
import getAutoReplenishSubscriptions from 'services/api/productFrequency/getAutoReplenishSubscriptions';
import unsubscribeAutoReplenishment from 'services/api/productFrequency/unsubscribeAutoReplenishment';
import pauseAutoReplenishment from 'services/api/productFrequency/pauseAutoReplenishment';
import skipAutoReplenishment from 'services/api/productFrequency/skipAutoReplenishment';
import resumeAutoReplenishment from 'services/api/productFrequency/resumeAutoReplenishment';
import updateReplenishSubscriptions from 'services/api/productFrequency/updateReplenishSubscriptions';
import addSubscriptionAddress from 'services/api/productFrequency/addSubscriptionAddress';
import updateSubscriptionAddress from 'services/api/productFrequency/updateSubscriptionAddress';
import updateSubscriptionWithExistingAddress from 'services/api/productFrequency/updateSubscriptionWithExistingAddress';

export default {
    getProductFrequency: getProductFrequency,
    getAutoReplenishSubscriptions: getAutoReplenishSubscriptions.getAutoReplenishSubscriptions,
    unsubscribeAutoReplenishment: unsubscribeAutoReplenishment.unsubscribeAutoReplenishment,
    pauseAutoReplenishment: pauseAutoReplenishment.pauseAutoReplenishment,
    skipAutoReplenishment: skipAutoReplenishment.skipAutoReplenishment,
    resumeAutoReplenishment: resumeAutoReplenishment.resumeAutoReplenishment,
    updateReplenishSubscriptions: updateReplenishSubscriptions.updateReplenishSubscriptions,
    addSubscriptionAddress: addSubscriptionAddress.addSubscriptionAddress,
    updateSubscriptionAddress: updateSubscriptionAddress.updateSubscriptionAddress,
    updateSubscriptionWithExistingAddress: updateSubscriptionWithExistingAddress.updateSubscriptionWithExistingAddress
};
